export default {
  "A confirmation code has just been sent to you by message": "認証コードをSMSで送信しました",
  "Already have an account": "既にアカウントをお持ちの方",
  "Beyond this time, the reservation we retain will be available again for others": "この時間を過ぎると、確保している予約は再び他のお客様に開放されます",
  "Book now": "今すぐ予約",
  "Booking": "予約",
  "Booking information": "予約情報",
  "Booking start the first day at {startTime} and finish the last day at {endTime}": "予約は初日の {startTime} に開始し、最終日の {endTime} に終了します",
  "Cancel booking": "予約をキャンセル",
  "Choose your date": "日付を選択してください",
  "Confirm my phone number": "電話番号を確認する",
  "Confirm my registration": "登録を確認する",
  "Confirm my booking": "予約を確認する",
  "Confirm my registration and pay": "登録を確認して支払う",
  "Continue as guest": "ゲストとして続ける",
  "Continue to registration": "登録に進む",
  "Create an account": "アカウントを作成",
  "Dates": "日付",
  "End Date of Reservation": "予約終了日",
  "Enlarge map": "地図を拡大",
  "Enter your code here to confirm your registration": "登録を確認するには、こちらにコードを入力してください",
  "I accept the Terms and conditions of registration": "登録の利用規約に同意します",
  "I accept the terms of service and confirm that I have read the privacy policy": "利用規約に同意し、プライバシーポリシーを読んだことを確認します",
  "Loading…": "読み込み中…",
  "Location": "場所",
  "More information": "詳細情報",
  "No slots available": "空き枠がありません",
  "Processing booking…": "予約を処理中…",
  "Processing payment…": "支払いを処理中…",
  "Product": "製品",
  "Recording payment…": "支払いを記録中…",
  "Reduce map": "地図を縮小",
  "Remaining time": "残り時間",
  "Required fields": "必須項目",
  "Reserving a product is mandatory for registration": "登録には製品の予約が必須です",
  "Retrieving available slots": "空き枠を取得中",
  "Saving registration…": "登録を保存中…",
  "Select size first": "先にサイズを選択してください",
  "Select stage first": "先にセッションを選択してください",
  "Select your options and dates to book": "予約するオプションと日付を選択してください",
  "Size": "サイズ",
  "Slot": "枠",
  "Stage": "セッション",
  "Store": "店舗",
  "Start Date of Reservation": "予約開始日",
  "View privacy policy": "プライバシーポリシーを見る",
  "View terms and conditions": "利用規約を見る",
  "You do not want to create an account": "アカウントを作成しない方",
  "The selected product has been set aside for you. You have {minutes} minutes to complete the process by providing your personal information.": "選択された製品はお客様のために確保されています。次のページで個人情報を入力し、{minutes} 分以内に手続きを完了してください。",
  "Your reservation is in progress!": "予約を処理中です！",
  "not available": "利用できません",
  "remaining place": "残り枠|残り枠",
  "see availability": "空き状況を見る",
  "Email Address": "メールアドレス",
  "Phone": "電話番号",
  "Birthdate": "生年月日",
  "ProductTypes": "製品タイプ",
  "Sizes": "サイズ",
  "Filter": "フィルター",
  "Select a date": "日付を選択",
  "Give us your opinion": "ご意見をお聞かせください",
  "Thank you for your review!": "レビューありがとうございます！",
  "You can also review these products": "これらの製品も評価できます",
  "Undo": "元に戻す",
  "Redo": "やり直す",
  "Bold": "太字",
  "Italic": "斜体",
  "Strikethrough": "取り消し線",
  "Paragraph": "段落",
  "Add Link": "リンクを追加",
  "Remove Link": "リンクを削除",
  "Headings": "見出し",
  "Heading 2": "見出し 2",
  "Heading 3": "見出し 3",
  "Heading 4": "見出し 4",
  "Heading 5": "見出し 5",
  "Heading 6": "見出し 6",
  "Bullet List": "箇条書きリスト",
  "Numbered List": "番号付きリスト",
  "Clear Formatting": "書式をクリア",
  "Overall Rating": "総合評価",
  "Review title": "レビュータイトル",
  "Summarize your impression on the product": "製品の印象を要約してください",
  "Your detailed product review": "製品の詳細なレビュー",
  "50 characters minimum": "50文字以上",
  "What was your impression of the product while testing? What did you like or dislike about the product? What conditions where present while testing the product?": "テスト中の製品の印象はいかがでしたか？製品のどこが気に入りましたか、または気に入りませんでしたか？テスト時の状況はどうでしたか？",
  "50 characters (minimum)": "50文字（最小）",
  "Comments": "コメント",
  "Comments on the reception, the organization, the advice on the product…": "受付、運営、製品に関するアドバイスへのコメント…",
  "Would you recommend this product to a friend?": "この製品を友人に勧めますか？",
  "Would you be ready to buy this product?": "この製品を購入したいと思いますか？",
  "First name or pseudo": "名前またはニックネーム",
  "Your name / nickname is published with your review": "お名前／ニックネームはレビューとともに公開されます",
  "I have read and I accept the terms and conditions": "利用規約を読み、同意します",
  "of publication of the reviews": "レビューの公開に関する",
  "and": "および",
  "the privacy policy": "プライバシーポリシー",
  "Post Review": "レビューを投稿",
  "Very bad": "非常に悪い",
  "Bad": "悪い",
  "Average": "普通",
  "Good": "良い",
  "Great!": "非常に良い！",
  "Image caption": "画像キャプション",
  "No": "いいえ",
  "Yes": "はい",
  "Booking dates": "予約日",
  "Registration": "登録",
  "Status": "ステータス",
  "Created at": "作成日時",
  "Actions": "操作",
  "Cancel": "キャンセル",
  "This site is protected by reCAPTCHA.": "このサイトは reCAPTCHA によって保護されています。",
  "Google Privacy Policy": "Google プライバシー ポリシー",
  "Google Terms of Service": "Google 利用規約",
};
